import { render, staticRenderFns } from "./nomenklaturaList.vue?vue&type=template&id=37b6b370&scoped=true&"
import script from "./nomenklaturaList.vue?vue&type=script&lang=js&"
export * from "./nomenklaturaList.vue?vue&type=script&lang=js&"
import style0 from "./nomenklaturaList.vue?vue&type=style&index=0&id=37b6b370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b6b370",
  null
  
)

export default component.exports